export const BASE_URL = "https://sitolaut.dephub.go.id/ternak-api/";
export const UPLOAD_URL =
  "https://sitolaut.dephub.go.id/uploads/ternak/uploads";
// export const UPLOAD_URL = 'http://localhost/Tollaut_Ternak_Phase_1/lcs_ternak_api_phase_1/public/uploads'
// export const BASE_URL = 'http://localhost:7024/'

export const CONSIGNEE_PANDUAN_URL =
  "https://drive.google.com/folderview?id=12vESYuR6c3XE3PcV50nZTUEqQO3rxgqu";
export const SHIPPER_PANDUAN_URL =
  "https://drive.google.com/folderview?id=12vESYuR6c3XE3PcV50nZTUEqQO3rxgqu";
export const OPERATOR_PANDUAN_URL =
  "https://drive.google.com/folderview?id=12vESYuR6c3XE3PcV50nZTUEqQO3rxgqu";
export const REGULATOR_PANDUAN_URL =
  "https://drive.google.com/folderview?id=12vESYuR6c3XE3PcV50nZTUEqQO3rxgqu";

//export const CONSIGNEE_PANDUAN_URL = 'http://localhost/tollaut/panduan/'
//export const SHIPPER_PANDUAN_URL = 'http://localhost/tollaut/panduan/'
//export const OPERATOR_PANDUAN_URL = 'http://localhost/tollaut/panduan/'
//export const REGULATOR_PANDUAN_URL = 'http://localhost/tollaut/panduan/'

export const NAME_KEY = "name@tol-laut-ternak";
export const USERID_KEY = "userid@tol-laut-ternak";
export const TOKEN_KEY = "token@tol-laut-ternak";
export const USER_TYPE_ID = "userTypeId@tol-laut-ternak";
export const USER_TYPE_FORM = "userTypeForm@tol-laut-ternak";

export const USER_TYPE_NAME = "userTypeName@tol-laut-ternak";
export const USER_EMAIL = "userEmail@tol-laut-ternak";

export const APP_NAME = "Tol Laut Ternak";
export const COMPANY_NAME = "PT.NUTECH INTEGRASI";

export const MAX_UPLOAD = "512KB";

export const FORM_CONSIGNEE = "consignee";
export const FORM_SHIPPER = "shipper";
export const FORM_OPERATOR = "operator";
export const FORM_REGULATOR = "regulator";
export const FORM_VISITOR = "visitor";

export const SITE_KEY = "6LcEYOYUAAAAAPG2Z-FJApIQ9mJg0be-2o-MYoFa";
export const IS_CAPTCHA = "ENABLE";

export const ID_CONSIGNEE = 1;
export const ID_SHIPPER = 2;
export const ID_OPERATOR = 3;
export const ID_REGULATOR = 4;
export const ID_VISITOR = 5;
export const ID_KEMENDAG = 9;
export const ID_KEMENTAN = 13;
export const ID_DISNAK = 14;

export const STATUS_WAITING = "waiting";
export const STATUS_APPROVE = "approved";
export const STATUS_REJECT = "rejected";

export const STATUS_WAITING_REGULATOR = 3;
export const STATUS_APPROVE_REGULATOR = 1;
export const STATUS_REJECT_REGULATOR = 2;

export const STATUS_NEW = 1;
export const STATUS_WAITING_FOR_PAYMENT = 2;
export const STATUS_WAITING_FOR_PAYMENT_VALIDATION = 3;
export const STATUS_REJECTED = 4;
export const STATUS_PAYMENT_NOT_VALID = 5;
export const STATUS_BL_PROCESS = 6;
export const STATUS_FINISH = 7;
export const STATUS_WAITING_DISNAK = 8;
export const STATUS_REJECTED_DISNAK = 9;

export const REPORT_STATUS_USER_URL = "report/status_user";
export const REPORT_STATUS_ORDER_URL = "report/status_order";
export const REPORT_DATA_USER_URL = "report/data_user";
export const REPORT_ORDER_PERBULAN_URL = "report/order_perbulan";
export const REPORT_REALISASI_MUATAN_PER_OPERATOR_URL =
  "report/realisasi_muatan_per_operator";
export const REPORT_ORDER_PER_PORT_URL = "report/order_per_port";
export const REPORT_SISA_KUOTA_URL = "report/sisa_kuota";
export const REPORT_ORDER_JENIS_MUATAN_PER_PRIORITAS_URL =
  "report/jenis_muatan_per_prioritas";
export const REPORT_MUATAN_PER_WILAYAH_URL = "report/muatan_per_wilayah";
export const REPORT_MUATAN_PER_WILAYAH_PER_JENIS_HEWAN_URL =
  "report/muatan_per_wilayah_per_jenis_hewan";
export const REPORT_ORDER_PER_JENIS_HEWAN_URL = "report/order_per_jenis_hewan";
export const REPORT_REALISASI_VOYAGE_PER_TRAYEK_URL =
  "report/realisasi_voyage_per_trayek";
export const REPORT_WAKTU_TEMPUH_URL = "report/waktu_tempuh";
